import axios from 'utils/axios';
import UpdateParam, { NewUpdateParam } from 'models/requests/UpdateParam';

class ParamsService {
    async updateParams(params: NewUpdateParam): Promise<boolean> {
        try {
            const res = await axios.post<boolean>('/UpdateParams', params);
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch update Params');
        }
    }
}

export default ParamsService;
